import classnames from 'classnames';
import PropTypes from 'prop-types';
import React, { useContext } from 'react';
import { Button } from '@sm/wds-react';
import { StaticContext } from '@sm/webassets';

import { PACKAGE_IDS } from '~pricing/lib/constants';

const PackageCta = ({ packageName, packageClassName }) => {
  const { user } = useContext(StaticContext);
  const packageId = PACKAGE_IDS[packageName];
  const className = classnames([
    'sm-package__btn',
    `sm-package__btn--${packageClassName}`
  ]);
  const ctaUrl = user.isAuthenticated
    ? `/billing/checkout/?package_id=${packageId}`
    : `/user/sign-up`;
  const ctaText = user.isAuthenticated ? 'SELECT' : 'SIGN UP';

  return (
    <Button
      href={ctaUrl}
      className={className}
      stretched
      data-testid="PackageCta_Button"
    >
      {ctaText}
    </Button>
  );
};

PackageCta.propTypes = {
  packageName: PropTypes.string.isRequired,
  packageClassName: PropTypes.string.isRequired
};

export default PackageCta;
